export default __webpack_public_path__ + "static/media/GridDuck-logo.d69a31f9.png";